import { FC } from 'react';
import { Flex, Skeleton, Text } from '@eqi-investimentos/react';
import { MapRender } from '@/utils/jsx';

export const SkeletonWidgetListSlide: FC<SkeletonWidgetListSlideProps> = ({
  title = '',
}) => {
  return (
    <Flex
      pos="relative"
      flexDir="column"
      top="0.375rem"
      alignItems="start"
      gap="1.875rem"
    >
      <Text color={'content.primary'} size="l">
        {title}
      </Text>
      <Flex flexDir="row" w="full" gap="4">
        <MapRender
          items={[...Array(3).keys()]}
          render={(_, idx) => (
            <Skeleton
              key={idx}
              w="21.875rem"
              h="32.625rem"
              borderRadius="8px"
            />
          )}
        />
      </Flex>
    </Flex>
  );
};

interface SkeletonWidgetListSlideProps {
  title?: string;
}
